module.exports = __webpack_public_path__ + "static/media/W5390484_18.6252f6e0.jpg";